import { ResidentialStatus } from '../../../../shared/models/enums/residential-status.enum';
import { StructureDto } from '../../../../shared/models/structure.dto';
import { ChildrenDto } from './childrenDto';
import { DiagnosticBarrierDto } from './diagnosticBarrierDto';
import { DiagnosticQualificationDto } from './diagnosticQualificationDto';
import { FormationDto } from './formationDto';

export class DiagnosticDto {
  constructor(
    public id: number,
    public idBeneficiary: number,
    public beginDateOrientation: Date,
    public diagnosticStatus: string,
    public statusDate: Date,
    public title: string,
    public usualName: string,
    public firstName: string,
    public birthDate: Date,
    public address: string,
    public additionalAddress: string,
    public city: string,
    public postalCode: string,
    public residentialStatus: ResidentialStatus,
    public residentialStatusComplement: string,
    public maritalStatus: string,
    public spouseAge: string,
    public spouseOccupation: string,
    public jobCenterRegistration: boolean,
    public RSA: boolean,
    public RQTH: boolean,
    public mission: string,
    public natureLastJob: string,
    public beginDateLastJob: Date,
    public endDateLastJob: Date,
    public degreeId: number,
    public degreeLabel: string,
    public highestDegree: string,
    public drivingLicense: boolean,
    public drivingLicenses: DiagnosticQualificationDto[] = [],
    public skills: string,
    public barriers: DiagnosticBarrierDto[] = [],
    public structureId: number,
    public structure: StructureDto,
    public referentId: number,
    public project: string,
    public analysis1: string,
    public analysis2: string,
    public analysis3: string,
    public analysis4: string,
    public analysis5: string,
    public analysis6: string,
    public children: ChildrenDto[] = [],
    public formations: FormationDto[] = [],
  ) {}

  public static fromJson(json: any): DiagnosticDto {
    if (!json) {
      return;
    }
    return new DiagnosticDto(
      json.id,
      json.idBeneficiary,
      json.beginDateOrientation ? new Date(json.beginDateOrientation) : undefined,
      json.diagnosticStatus,
      json.statusDate ? new Date(json.statusDate) : undefined,
      json.title,
      json.usualName,
      json.firstName,
      json.birthDate ? new Date(json.birthDate) : undefined,
      json.address,
      json.additionalAddress,
      json.city,
      json.postalCode,
      json.residentialStatus,
      json.residentialStatusComplement,
      json.maritalStatus,
      json.spouseAge,
      json.spouseOccupation,
      json.jobCenterRegistration,
      json.RSA,
      json.RQTH,
      json.mission,
      json.natureLastJob,
      json.beginDateLastJob ? new Date(json.beginDateLastJob) : undefined,
      json.endDateLastJob ? new Date(json.endDateLastJob) : undefined,
      json.degreeId,
      json.degreeLabel,
      json.highestDegree,
      json.drivingLicense,
      json.drivingLicenses && Array.isArray(json.drivingLicenses) ? json.drivingLicenses.map(DiagnosticQualificationDto.fromJson) : [],
      json.skills,
      json.barriers && Array.isArray(json.barriers) ? json.barriers.map(DiagnosticBarrierDto.fromJson) : [],
      json.structureId,
      json.structure,
      json.referentId,
      json.project,
      json.analysis1,
      json.analysis2,
      json.analysis3,
      json.analysis4,
      json.analysis5,
      json.analysis6,
      json.children && Array.isArray(json.children) ? json.children.map(ChildrenDto.fromJson) : [],
      json.formations && Array.isArray(json.formations) ? json.formations.map(FormationDto.fromJson) : [],
    );
  }
}
